import { render, staticRenderFns } from "./page5.vue?vue&type=template&id=4a634faa&scoped=true&"
import script from "./page5.vue?vue&type=script&lang=ts&"
export * from "./page5.vue?vue&type=script&lang=ts&"
import style0 from "./page5.vue?vue&type=style&index=0&id=4a634faa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a634faa",
  null
  
)

export default component.exports